import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon_close.png'
import _imports_1 from '@/assets/image/vipImg/popup_new_user_head_long.png'


const _hoisted_1 = { class: "set-shop-content" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "set-shop-dialog-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "set-shop-dialog-bg"
}, null, -1)
const _hoisted_5 = { class: "set-shop-dialog-tab" }
const _hoisted_6 = { class: "set-shop-dialog-tab-content" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"word-break":"break-word"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"word-break":"break-word"} }
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"word-break":"break-word"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"1px solid #F5F5F5"} }, null, -1)
const _hoisted_14 = { class: "add-shop" }
const _hoisted_15 = { class: "add-shop" }
const _hoisted_16 = { class: "add-shop" }
const _hoisted_17 = { class: "set-shop-btn" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { isD2C, useSite, isEN } from '@/store'
import CreateShopItem from '@/components/common/CreateShopItem.vue'
import ShopPurchase from '@/views/setup/components/ShopPurchase.vue'
import ShopExpress from './ShopExpress.vue'
import { useStore } from 'vuex'
import { ElMessage as message } from 'element-plus'
import { wordBreak } from 'html2canvas/dist/types/css/property-descriptors/word-break'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  vipInfo: {
    type: Object,
    default: () => { return {} }
  }
},
  emits: ['update:visible', 'submit'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()
const shopInfo = computed(() => {
  let shop = ''
  if (store.getters.user?.customerShopList) {
    store.getters.user.customerShopList.forEach((item: any) => {
      if (item.customerShopId === store.state.route.curShop) {
        shop = {
          ...item,
          customerShopPlatform: parseInt(item.shopPlatform)
        }
      }
    })
  }

  return shop
})

const activeStep = ref(1)
if (shopInfo.value.customerShopId) {
  activeStep.value = 2
}
const isNewCustomer = !shopInfo.value.customerShopId
const getStepIconImage = (type: any) => {
  if (type === 1) {
    return isD2C() ? (
      activeStep.value === 1 ? require('@/assets/image/vipImg/icon_shop_green.png') : require('@/assets/image/vipImg/icon_shop_green_unclick.png')
    ) : (activeStep.value === 1 ? require('@/assets/image/vipImg/icon_shop_blue.png') : require('@/assets/image/vipImg/icon_shop_blue_unclick.png'))
  } else if (type === 2) {
    return isD2C() ? (
      activeStep.value === 2 ? require('@/assets/image/vipImg/icon_purchase_green.png') : require('@/assets/image/vipImg/icon_purchase_green_unclick.png')
    ) : (activeStep.value === 2 ? require('@/assets/image/vipImg/icon_purchase_blue.png') : require('@/assets/image/vipImg/icon_purchase_blue_unclick.png'))
  } else if (type === 3) {
    return isD2C() ? (
      activeStep.value === 3 ? require('@/assets/image/vipImg/icon_delivery_green.png') : require('@/assets/image/vipImg/icon_delivery_green_unclick.png')
    ) : (activeStep.value === 3 ? require('@/assets/image/vipImg/icon_delivery_blue.png') : require('@/assets/image/vipImg/icon_delivery_blue_unclick.png'))
  }
}

const close = () => {
  store.commit('status/editing', false)
  emit('update:visible', false)
  emit('submit')
}
const createShopItemRef = ref()
const shopPurchaseRef = ref()
const shopExpressRef = ref()

const next = () => {
  console.log(activeStep.value, 'activeStep')
  console.log('1')
  if (activeStep.value === 1) {
    console.log('2')
    activeStep.value = 2
  } else if (activeStep.value === 2 && isD2C()) {
    console.log('3')
    activeStep.value = 3
  } else if (activeStep.value === 3 || (activeStep.value === 2 && !isD2C())) {
    console.log('4')
    // 保存
    // 第一步校验店铺信息是否完整
    createShopItemRef.value.checkForm(() => {
      console.log('5')
      // 第二步校验采购设置
      shopPurchaseRef.value.checkForm(() => {
        console.log('6')
        if (!isD2C()) {
          createShopItemRef.value.authorize()
          return
        }
        console.log('7')
        // 第三步校验国际配送设置
        shopExpressRef.value.checkForm(() => {
          console.log('8')
          createShopItemRef.value.authorize()
        }, () => {
          message.warning(t('请填写完成国际配送设置'))
        })
      }, () => {
        activeStep.value = 2
        message.warning(t('请填写完成采购设置'))
      })
    }, () => {
      activeStep.value = 1
      message.warning(t('请填写完成店铺信息'))
    })
  }
}

// 店铺保存后回调
const shopSubmit = (id: any) => {
  if (!store.state.route.curShop) {
    // 没有店铺先切换店铺
    store.commit('route/SET_SHOP_ID', id)
    shopPurchaseRef.value.firstupdate()
  } else {
    shopPurchaseRef.value.update()
  }
}

// 采购设置保存
const purchaseSubmit = () => {
  if (isD2C()) {
    shopExpressRef.value.updateLogistics(isNewCustomer)
  } else {
    emit('submit')
  }
}
const expressSubmit = () => {
  emit('submit')
}

const changeTab = (num: number) => {
  console.log(createShopItemRef.value.model)
  store.commit('route/SET_SHOP_INFO', createShopItemRef.value.model)
  activeStep.value = num
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "custom-class": "set-shop-dialog",
      "model-value": __props.visible,
      onClose: close,
      "append-to-body": "",
      "show-close": false,
      "destroy-on-close": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: close,
            class: "close-icon"
          }),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_unref(isEN)())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["title", _unref(useSite)()])
                }, [
                  _createTextVNode(_toDisplayString(_unref(t)('恭喜成功开通')), 1),
                  _createElementVNode("span", null, "【" + _toDisplayString(__props.vipInfo.priceName) + "】", 1),
                  _createTextVNode(_toDisplayString(_unref(t)('为了更好地帮您履行下单履约，您需要提前填写以下信息。')), 1)
                ], 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["title", _unref(useSite)()])
                }, [
                  _createElementVNode("span", null, "【" + _toDisplayString(__props.vipInfo.priceName) + "】", 1),
                  _createTextVNode(_toDisplayString(_unref(t)('恭喜成功开通')) + _toDisplayString(_unref(t)('为了更好地帮您履行下单履约，您需要提前填写以下信息。')), 1)
                ], 2))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(_unref(isD2C)() ? '' : 'set-shop-dialog-tab-padding')
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass([{ active: activeStep.value === 1 }, 'set-shop-dialog-tab-item']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(1)))
                }, [
                  _createElementVNode("img", {
                    src: getStepIconImage(1),
                    alt: ""
                  }, null, 8, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('添加店铺')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{ active: activeStep.value === 2 }, 'set-shop-dialog-tab-item']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(2)))
                }, [
                  _createElementVNode("img", {
                    src: getStepIconImage(2),
                    alt: ""
                  }, null, 8, _hoisted_9),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('采购设置')), 1)
                ], 2),
                (_unref(isD2C)())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([{ active: activeStep.value === 3 }, 'set-shop-dialog-tab-item']),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(3)))
                    }, [
                      _createElementVNode("img", {
                        src: getStepIconImage(3),
                        alt: ""
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('国际配送设置')), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _hoisted_13
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_14, [
          _createVNode(CreateShopItem, {
            vip: true,
            ref: (_value, _refs) => {
              _refs['createShopItemRef'] = _value
              createShopItemRef.value = _value
            },
            shopData: _unref(shopInfo),
            onOk: shopSubmit
          }, null, 8, ["shopData"])
        ], 512), [
          [_vShow, activeStep.value === 1]
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(ShopPurchase, {
                vip: true,
                ref: (_value, _refs) => {
                  _refs['shopPurchaseRef'] = _value
                  shopPurchaseRef.value = _value
                },
                onOk: purchaseSubmit
              }, null, 512), [
                [_vShow, activeStep.value === 2]
              ])
            ]),
            _: 1
          }))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_16, [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _createVNode(ShopExpress, {
                vip: true,
                ref: (_value, _refs) => {
                  _refs['shopExpressRef'] = _value
                  shopExpressRef.value = _value
                },
                onOk: expressSubmit
              }, null, 512)
            ]),
            _: 1
          }))
        ], 512), [
          [_vShow, activeStep.value === 3]
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            class: "btn",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('暂不设置')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            style: {"margin-left":"20px"},
            onClick: next
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString((_unref(isD2C)() && activeStep.value == 3 ||
          !_unref(isD2C)() && activeStep.value === 2) ? _unref(t)('保存设置') :
          _unref(t)('下一步')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})